<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">

        <div class="dialog-input-item">
          <DatePickerRange title="支付时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="dialog-input-item">
          <label>支付门店</label>
          <el-select v-model="shopId" placeholder="Select" class="select-item">
            <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <label>预约类型</label>
          <el-select v-model="preBookState" placeholder="Select" class="select-item">
            <el-option v-for="item in preBookStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <!--          <label>记录搜索</label>-->
          <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <!--            <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>-->
        </div>

      </div>

      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <!--          <el-button type="success" @click="add">添加</el-button>-->
        </div>
        <div class="dialog-input-btn">
          <ElButtons type="success" icon="Plus"  @click="add"> 添加 </ElButtons>
<!--          <el-button type="success" @click="add">添加</el-button>-->
        </div>
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="createTime" label="时间" width="200"/>
      <el-table-column property="shopName" label="支付门店" width="100"/>
      <el-table-column property="tradeNo" label="支付编号" width="200"/>
      <el-table-column property="content" label="支付记录"/>
      <el-table-column property="" label="类型" width="100">
        <template #default="scope">
          {{scope.row.preBookId > 0?'预约单':'非预约单'}}
        </template>
      </el-table-column>
      <el-table-column property="adminName" label="添加人" width="100"/>
      <el-table-column property="" label="操作" width="100">
        <template #default="scope">
          <el-button type="text" @click="checkDetail(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import {getAllShopList, getPaymentDetailPageList, getUserInfo, getRecordShops} from '@/api/url';
import Dialog from '@/assets/js/dialog'
import Drawer from '@/assets/js/drawer'
// import AddUserRemarkDialog from './AddUserRemarkDialog';
import DatePickerRange from "@/components/DatePickerRange_30";
import SearchComponents from "@/components/SearchComponents";
import PayDetailDialog from "@/views/user/components/payment/PayDetailDialog";
import EditPaymentDialog from "@/views/user/components/payment/EditPaymentDialog";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, SearchComponents},
  data() {
    return {
      userForm: this.value.userForm,
      pageDataList: [],
      id: this.value.id,
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      preBookStateArray: [
        {label: '不限', value: -1},
        {label: '预约单', value: 1},
        {label: '非预约单', value: 2},
      ],
      preBookState: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //搜索
      searchTypeList: [
        {label : '支付编号', value : 1},
        {label : '添加人', value : 2},
      ],
      searchType: 1,
      searchValue: '',

      shopIdArray: [],
      shopIdArr:[],
      shopId: 0,

      visibleShopList: JSON.parse(sessionStorage.getItem('visibleShopList')),

    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.id;
      param['preBookState'] = this.preBookState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['shopId'] = this.shopId;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getPaymentDetailPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    add() {
      let payDetailForm = {};
      Drawer.open({
        title: '添加支付记录',
        component: EditPaymentDialog,
        data: {
          userForm: this.userForm,
          // userId: this.userForm.id,
          idx: -1,
          payDetailForm: payDetailForm,
          checkList: this.userForm.petIdList,
          width: 800
        },
        confirm: (result) => {
          this.getUserInfo()
          this.getPage();
          sessionStorage.setItem('recordState', JSON.stringify(true))
        }
      })
    },

    getUserInfo() {
      getFormData(getUserInfo, {id: this.userForm.id}).then(data => {
        this.userForm = data.data
      })
    },

    checkDetail(row) {
      // if(this.visibleShopList.every(item => item.id != row.shopId)) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '当前角色没有该门店的编辑权限',
      //     type: 'warning'
      //   });
      //   return false
      // }
      let payDetailForm = Object.assign({}, row);
      Dialog.open({
        title: '',
        component: PayDetailDialog,
        data: {
          userForm: this.userForm,
          payDetailForm: payDetailForm
        },
        confirm: (result) => {
          this.getPage();
          this.getUserInfo()
          sessionStorage.setItem('recordState', JSON.stringify(true))
        }
      })
    },

    getShopList() {
      let param = {}
      param['userId'] = this.userForm.id
      param['type'] = 2
      getFormData(getRecordShops, param).then(data=> {
        data.data.map((item) => {
          this.shopIdArr.push(item)
        })
        this.shopIdArray = this.shopIdArray.concat(this.shopIdArr)
      })
    }

  },
  mounted() {
    this.getShopList()
    this.getPage();
  }
}
</script>

<style>

</style>
